module.exports = __webpack_public_path__ + "static/tvr-heritage-1af3e9a4983e03288f1c81bc1f6c2489.png";